import Header from '../components/Header';
import Footer from '../components/Footer';
import { stayProperties } from './stayProperties';
import './StayPage.css';

export default function StayPage() {
  return <>
    <Header homeHref="/" />
    <main id="main-content" className="stay-listing" tabIndex={-1}>
      <p className="stay-listing__eyebrow">THREE PLACES. ONE WARM WELCOME.</p>
      <h1>Find your kind of escape.</h1>
      <p className="stay-listing__intro">Find time to rest and explore in Georgia, Jamaica or Oregon.</p>
      <div className="stay-listing__grid">
        {Object.values(stayProperties).map(property => <article key={property.id} className="stay-listing__card">
          {property.image ? <img src={`${process.env.PUBLIC_URL}/images/${property.image}`} alt={property.alt} width="900" height="600" loading="lazy" /> : <div className="property-photo-pending">Property photographs to follow</div>}
          <div className="stay-listing__copy"><p className="stay-listing__eyebrow">JAMROCK ESCAPE</p><h2>{property.name}</h2><p>{property.introduction}</p><a href={property.path} aria-label={`View property: ${property.name}`}>View property <span aria-hidden="true">↗</span></a></div>
        </article>)}
      </div>
      <p className="stay-listing__note">Explore each stay for photographs, property details and booking enquiries.</p>
    </main>
    <Footer />
  </>;
}
